import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import CompanySignup from './pages/CompanySignup';
import NotFound from './pages/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

import Listings from './pages/Listings';
import ListingDetail from './pages/ListingDetail';
import CreateListing from './pages/CreateListing';
import EditListing from './pages/EditListing';

import NewOrder from './pages/orders/NewOrder';
import OrderDetail from './pages/orders/OrderDetail';
import ModifyOrder from './pages/orders/ModifyOrder';

import CompanyOrders from './pages/company/CompanyOrders';
import CompanyListings from './pages/company/CompanyListings';
import CustomerOrders from './pages/customer/CustomerOrders';

import MyProfile from './pages/MyProfile';
import PublicProfile from './pages/PublicProfile';
import Notifications from './pages/Notifications';
import SearchResults from './pages/SearchResults';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import { NotificationProvider } from './context/NotificationContext';

function App() {
  return (
    <BrowserRouter>
      <NotificationProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
      <Routes>
        {/* Public */}
        <Route path="/"        element={<Home />} />
        <Route path="/login"   element={<Login />} />
        <Route path="/signup"  element={<Signup />} />
        <Route path="/signup/company"  element={<CompanySignup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
        <Route path="/search"      element={<SearchResults />} />
        <Route path="/privacy"     element={<PrivacyPolicy />} />
        <Route path="/terms"       element={<TermsOfUse />} />
        <Route path="/listings"    element={<Listings />} />
        <Route path="/listings/:id" element={<ListingDetail />} />
        <Route path="/users/:userId" element={<PublicProfile />} />

        {/* Protected — company only */}
        <Route path="/listings/create"   element={<ProtectedRoute allowedRoles={['company']}><CreateListing /></ProtectedRoute>} />
        <Route path="/listings/:id/edit" element={<ProtectedRoute allowedRoles={['company']}><EditListing /></ProtectedRoute>} />
        <Route path="/company/orders"    element={<ProtectedRoute allowedRoles={['company']}><CompanyOrders /></ProtectedRoute>} />
        <Route path="/company/listings"  element={<ProtectedRoute allowedRoles={['company']}><CompanyListings /></ProtectedRoute>} />

        {/* Customer only, but guests may also start a request (name/phone/location collected inline) */}
        <Route path="/orders/new"        element={<ProtectedRoute allowedRoles={['customer']} allowGuest><NewOrder /></ProtectedRoute>} />
        <Route path="/orders/:id/modify" element={<ProtectedRoute allowedRoles={['customer']}><ModifyOrder /></ProtectedRoute>} />
        <Route path="/customer/orders"   element={<ProtectedRoute allowedRoles={['customer']}><CustomerOrders /></ProtectedRoute>} />

        {/* Protected — any authenticated user */}
        <Route path="/orders/:id"        element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />

        {/* Public — a guest tracks their own order via the unguessable token from checkout */}
        <Route path="/orders/track/:token" element={<OrderDetail />} />

        <Route path="/my-profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      </main>
      <Footer />
      </div>
      </NotificationProvider>
    </BrowserRouter>
  );
}

export default App;
